import { OrganizationMember } from '@prisma/client'
import { message } from 'antd'
import { useSdk } from '../../../hooks/useSdk'
import { UIChatItem, UIChatReaction } from '../types'

type Props = {
  organizationMember: OrganizationMember
}

export const useReactions = ({ organizationMember }: Props) => {
  const sdk = useSdk({ organizationMember })

  const setReaction = async (item: UIChatItem, reaction: UIChatReaction) => {
    try {
      const messageId = item.id

      await sdk.addReaction({
        messageId,
        reaction,
      })
    } catch (error) {
      message.error('Something went wrong')
      console.error('Unknown Error', error)
    }
  }

  return {
    setReaction,
  }
}
